<template>
  <v-main>
    <v-container>
      <div class="page login">
        <v-card style="width: 400px" class="mx-auto mt-16 rounded-lg px-3">
          <v-card-title class="text-center">
            <h4 class="text-h4 mx-auto">Accedi</h4>
          </v-card-title>
          <v-card-text>
            <v-alert text type="error" v-if="error">
              {{ error }}
            </v-alert>
            <v-form v-model="valid" ref="form" lazy-validation :disabled="loading" class="my-6">
              <v-text-field
                v-model.trim="form.username"
                label="Username"
                outlined
                :rules="[rules.required, rules.min]"
              />
              <v-text-field
                v-model.trim="form.password"
                label="Password"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                outlined
                @click:append="showPassword = !showPassword"
                :rules="[rules.required, rules.min]"
              />
              <v-btn
                color="primary"
                block
                depressed
                x-large
                class="rounded-lg mt-4"
                @click="onSubmit"
                :loading="loading"
                >Accedi</v-btn
              >
            </v-form>
          </v-card-text>
        </v-card>
      </div>
    </v-container>
  </v-main>
</template>

<script>
// Store
import { mapActions, mapState } from 'vuex'

// Validations
import { required } from '@/validations'

// Component
export default {
  name: 'LoginPage',
  components: {},
  data() {
    return {
      valid: true,
      showPassword: false,
      error: null,
      form: {
        username: '',
        password: '',
      },
      rules: {
        required,
        min: (v) => v.length >= 5 || 'Minimo 5 caratteri',
      },
    }
  },
  computed: {
    ...mapState('auth', ['loading']),
  },
  methods: {
    ...mapActions('auth', ['login']),
    async onSubmit() {
      try {
        await this.$refs.form.validate()
        if (!this.valid) return

        await this.login(this.form)

        this.$nextTick(() => {
          this.$router.replace(this.$route.query.redirect || '/admin')
        })
      } catch (error) {
        this.error = error.message
      }
    },
  },
}
</script>
